import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './BurgerMenuIcon.css';

const BurgerMenuIcon = ({ className }) => (
  <div className={classNames(className, styles.wrapper)}>
    <div className={styles.navBurger}>
      <span className={styles.line} />
      <span className={styles.line} />
      <span className={styles.line} />
    </div>
  </div>
);

BurgerMenuIcon.displayName = 'BurgerMenuIcon';

BurgerMenuIcon.propTypes = {
  /** custom styles */
  className: PropTypes.string,
};

export default BurgerMenuIcon;
